import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnUser } from '@lib/api/entities';

@Component({
  selector: 'sn-user-last-active',
  templateUrl: './user-last-active.component.html',
  styleUrls: ['./user-last-active.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnUserLastActiveComponent {
  @Input() public user: SnUser;
  @Input() public dateFormat: string = 'medium';
  @Input() public prefix: string = '';
}
